import {
  CreateCartParentGA4Object,
  CreateCartItemsObject,
} from './cart-helpers.js';

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {bubbles: true});
    this.quickAsParent = this.closest('.petivity-quick-view__quantity-wrapper');

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );

    if (this.quickAsParent && this.input.value <= 1) {
      this.querySelector('button[name="minus"]').setAttribute('disabled', true);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      this.input.stepUp();
      this.querySelector('button[name="minus"]').removeAttribute('disabled');
    } else {
      this.input.stepDown();
      if (this.quickAsParent && this.input.value <= 1) {
        this.querySelector('button[name="minus"]').setAttribute(
          'disabled',
          true,
        );
      }
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    const ns_quantity_input = {
      SubTotalEl: document.getElementById('subTotal'),

      RemoveCartItem(e) {
        if (event.target.name === 'minus') {
          const cartItem = e.target.closest('.cart-item');
          if (cartItem) {
            CreateCartItemsObject(
              cartItem,
              CreateCartParentGA4Object(
                'remove_from_cart',
                ns_quantity_input.SubTotalEl,
              ),
              true,
              e,
            );
          }
        }
      },

      AddCartItem(e) {
        if (event.target.name === 'plus') {
          const cartItem = e.target.closest('.cart-item');
          if (cartItem) {
            CreateCartItemsObject(
              cartItem,
              CreateCartParentGA4Object(
                'add_to_cart',
                ns_quantity_input.SubTotalEl,
              ),
              true,
              e,
            );
          }
        }
      },
    };

    // Capture GA4 data - 'remove_from_cart'
    ns_quantity_input.RemoveCartItem(event);

    // Capture GA4 data - 'add_to_cart'
    ns_quantity_input.AddCartItem(event);
  }
}

customElements.define('quantity-input', QuantityInput);
